module.exports = __webpack_public_path__ + "c58629e330eaf128316a142320407d74.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff2
 ** module id = 19
 ** module chunks = 0
 **/